
import { supabase } from "@/integrations/supabase/client";
import { DogSchool } from "@/data/dogSchools";

/**
 * Fetch all unique cities that have dog schools
 */
export const fetchAllCities = async (): Promise<{ city: string; country: string }[]> => {
  try {
    console.log("Fetching all unique cities with dog schools...");
    
    // Query to get all unique cities with their countries
    const { data, error } = await supabase
      .from('hundeschuleList')
      .select('city, country')
      .not('city', 'is', null)
      .order('city');
    
    if (error) {
      console.error("Error fetching cities:", error);
      return [];
    }
    
    // Filter out duplicate cities and null values
    const uniqueCities = data
      .filter(item => item.city && item.city.trim() !== '')
      .filter((value, index, self) => 
        index === self.findIndex((t) => t.city === value.city && t.country === value.country)
      );
    
    console.log(`Found ${uniqueCities.length} unique cities with dog schools`);
    
    return uniqueCities;
  } catch (error) {
    console.error("Error in fetchAllCities:", error);
    return [];
  }
};

/**
 * Filter cities by country
 */
export const getCitiesByCountry = (cities: { city: string; country: string }[], country: string): { city: string; country: string }[] => {
  return cities.filter(city => 
    city.country?.toLowerCase() === country.toLowerCase() ||
    (country.toLowerCase() === "germany" && city.country === "Germany") ||
    (country.toLowerCase() === "austria" && city.country === "Austria")
  );
};

/**
 * Fetch dog schools by city name
 */
export const fetchDogSchoolsByCity = async (cityName: string): Promise<DogSchool[]> => {
  try {
    console.log(`Fetching dog schools for city: ${cityName}`);
    
    const { data, error } = await supabase
      .from('hundeschuleList')
      .select('*')
      .ilike('city', `%${cityName}%`);
    
    if (error) {
      console.error("Error fetching dog schools by city:", error);
      return [];
    }
    
    return data as unknown as DogSchool[];
  } catch (error) {
    console.error(`Error in fetchDogSchoolsByCity for ${cityName}:`, error);
    return [];
  }
};
